import React from 'react';

interface LogoProps {
  className?: string;
  withText?: boolean;
  withIcon?: boolean;
}

export const Logo: React.FC<LogoProps> = ({ className = "w-10 h-10", withText = true, withIcon = true }) => {
  return (
    <div className={`flex items-center ${withText && withIcon ? 'gap-3' : ''}`}>
      {withIcon && (
        <svg 
          viewBox="0 0 100 100" 
          fill="none" 
          xmlns="http://www.w3.org/2000/svg" 
          className={`${className} text-astral-purple`}
        >
          {/* Ring */}
          <circle cx="50" cy="50" r="38" stroke="currentColor" strokeWidth="8" />
          
          {/* Swoosh/Blade Shape */}
          <path 
            d="M 28 82 C 35 75, 60 50, 92 28 L 95 30 C 70 50, 45 75, 28 88 Z" 
            fill="currentColor" 
          />
          {/* Inner curve correction to match sharpness */}
          <path 
             d="M 30 80 Q 60 45 92 28 L 90 25 Q 55 40 25 75 Z"
             fill="currentColor"
          />
        </svg>
      )}
      {withText && (
        <span className="text-lg sm:text-2xl font-display font-bold tracking-[0.2em] text-white">
          ASTRAL<span className="text-astral-purple">VIBE</span>
        </span>
      )}
    </div>
  );
};